import React from "react";
import PropTypes from "prop-types";
import { capitalize } from "lodash";

import { ConnectCRMButton } from "./components";

function IntegrationApp({ name, ...props }) {
  const capitalizedName = capitalize(name);

  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: "1em",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: "40px", display: "flex", alignItems: "center" }}>
          <img
            src={`/images/logos/${name}-logo.png`}
            alt={`${capitalizedName} logo`}
            height="25px"
          />
        </div>
        <div style={{ fontSize: "24px" }} data-test="integration-app-name">
          {capitalizedName}
        </div>
      </div>

      <ConnectCRMButton {...props} crm={name} />
    </div>
  );
}

IntegrationApp.propTypes = {
  name: PropTypes.oneOf(["redtail", "wealthbox", "salesforce", "zapier"])
    .isRequired,
};

export default IntegrationApp;
